import { checkIsExternalUser, roles } from "../../helpers/Authorization/authorizationHelpers";
import ListPage from "../Customer/ListPage";
import UserPreferencesPage from "../UserPreferences/UserPreferences";

export default [
  {
    name: "home",
    parent: "root",
    url: "/",
    redirectTo: () => {
      if (checkIsExternalUser()) {
        return { state: "CustomerPurchaseOrders", params: { customerId: 0 } };
      }

      return { state: "customers" };
    }
  },
  {
    name: "customers",
    parent: "root",
    url: "/customers?viewState",
    component: ListPage,
    params: {
      viewState: { type: "string", dynamic: true }
    },
    defaultBreadcrumbItems: [{ to: "home", label: "breadcrumb.customers", icon: "home" }],
    requiredRoles: [roles.InternalExpert, roles.InternalStandard]
  },
  {
    name: "user-preferences",
    parent: "root",
    url: "/user-preferences",
    component: UserPreferencesPage,
    defaultBreadcrumbItems: [{ to: "home", label: "breadcrumb.customers", icon: "home" }, { to: "user-preferences", label: "user-preferences" }]
  }
];



// WEBPACK FOOTER //
// ./src/components/Router/customerStates.js